import styled from 'styled-components'
import { themeGet } from '@styled-system/theme-get'

export const StyledForm = styled.form`
  width: 100%;
`

export const TicketTypeContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 36px;
  padding-inline: ${themeGet('space.4')}px;
  border-radius: 17px;
  border: 1px solid ${themeGet('colors.line.secondary')};
`
